module.exports = __webpack_public_path__ + "static/media/trayvoBlue.7bc11b12.png";